import { BRAND } from "@/data/translations";

export const LogoBanner = () => (
    <section
        data-testid="logo-banner"
        aria-hidden="true"
        className="relative bg-black pt-24 md:pt-28 lg:pt-32 pb-4 md:pb-5 lg:pb-6 flex items-center justify-center"
    >
        <picture>
            <source srcSet={BRAND.logoDarkWebp} type="image/webp" />
            <img
                src={BRAND.logoDark}
                alt="Fit & Wellness — Luca La Capria"
                className="mx-auto w-64 sm:w-80 md:w-[420px] lg:w-[520px] xl:w-[620px] h-auto select-none drop-shadow-[0_0_36px_rgba(57,255,20,0.42)]"
                draggable="false"
                width="1100"
                height="320"
                decoding="async"
            />
        </picture>
    </section>
);
